import React from 'react';

const Declaration = () => {
  return (
    <div>
      <p className="font-bold text-center pb-4">1. ОБЩИЕ ПОЛОЖЕНИЯ</p>
      <p className="pb-2 indent-0">
        1.1. Настоящее Пользовательское соглашение (далее – Соглашение) регулирует отношения между Обществом с ограниченной ответственностью «МЕРИДИАН» (ОГРН:
        5087746158880, ИНН: 7734592378, юридический адрес: г. Москва, ул. Малая Калужская, д. 15, стр. 17, далее – Компания) и Пользователем, возникающие в
        процессе использования цифровой платформы учёта (далее — Платформа). Платформа включает веб-интерфейсы, расположенные по адресам:{' '}
        <a href="https://meridian.pro" target="_blank" rel="noopener noreferrer">
          https://meridian.pro
        </a>{' '}
        и{' '}
        <a href="https://lk.meridian.pro" target="_blank" rel="noopener noreferrer">
          https://lk.meridian.pro
        </a>
        , а также мобильные приложения Компании для iOS и Android (совместно — Программы).
      </p>
      <p className="pb-2 indent-0">
        1.2. В целях настоящего Соглашения под Пользователем понимается любое физическое или юридическое лицо, осуществляющее регистрацию на Платформе и/или
        использующее функционал Программ. Под Счётчиком понимается прибор учёта, зарегистрированный в Платформе, включая устройства с возможностью
        автоматической передачи показаний. Под GSM-счётчиком понимается счётчик, использующий для передачи данных SIM-карту и сети операторов сотовой связи.
        Под Wi-Fi-счётчиком — устройство, передающее данные через беспроводную сеть передачи данных (Wi-Fi).
      </p>
      <p className="pb-2 indent-0">
        1.3. Настоящее Соглашение регулирует отношения, возникающие исключительно при использовании счётчиков, поддерживающих автоматическую передачу показаний
        через Платформу. Устройства, не передающие данные автоматически, не подпадают под действие настоящего Соглашения.
      </p>
      <p className="pb-2 indent-0">
        1.4. Регистрация Пользователя и использование Платформы означает полное и безоговорочное согласие с условиями настоящего Соглашения.
      </p>
      <p className="pb-2 indent-0">
        1.5. Компания оставляет за собой право изменять условия настоящего Соглашения в одностороннем порядке. Обновления вступают в силу с момента размещения
        на Платформе, если не указано иное.
      </p>
      <p className="pb-2 indent-0">
        1.6. Все услуги и функции Платформы предоставляются «как есть», без гарантий непрерывности, точности или соответствия ожиданиям Пользователя.
        Пользователь принимает на себя риски, связанные с использованием Платформы.
      </p>
      <p className="pb-2 indent-0">
        1.7. Пользователь несёт персональную ответственность за актуальность и достоверность переданных данных, а также за безопасность своей учётной записи и
        конфиденциальность используемых авторизационных данных.
      </p>

      <p className="font-bold text-center py-4">2. ПОРЯДОК ИСПОЛЬЗОВАНИЯ И ДОСТУПА</p>
      <p className="pb-2 indent-0">
        2.1. Доступ к Платформе осуществляется через личный кабинет на сайте или в мобильном приложении. Регистрация учётной записи является обязательной для
        доступа к функциям передачи показаний и получения уведомлений.
      </p>
      <p className="pb-2 indent-0">
        2.2. Для корректного функционирования Платформы Пользователь обязуется своевременно вводить и обновлять данные по приборам учёта, если они не
        передаются автоматически.
      </p>
      <p className="pb-2 indent-0">
        2.3. Пользователь обязуется использовать Платформу добросовестно, не нарушая прав третьих лиц, не вмешиваясь в работу системы и не осуществляя
        действий, направленных на подрыв безопасности и целостности данных.
      </p>
      <p className="pb-2 indent-0">
        2.4. Передача показаний осуществляется бесплатно для всех типов счётчиков, за исключением устройств, использующих канал передачи данных на основе
        SIM-карт (GSM-счётчики).
      </p>
      <p className="pb-2 indent-0">
        2.5. За использование GSM-счётчика взимается плата в размере 180 (Сто восемьдесят) рублей в год за каждый такой счётчик. Указанная сумма включает
        автоматическую передачу показаний в личный кабинет Пользователя и отправку данных на портал mos.ru. Размер оплаты может быть изменён в одностороннем
        порядке в зависимости от тарифов операторов связи.
      </p>
      <p className="pb-2 indent-0">
        2.6. Использование Wi-Fi-счётчиков и других приборов с передачей данных без использования SIM-карт не требует дополнительной оплаты и осуществляется
        бесплатно в рамках настоящего Соглашения.
      </p>
      <p className="pb-2 indent-0">
        2.7. Пользователь вправе по своей инициативе предоставить Компании логин и пароль от личного кабинета управляющей компании, ТСЖ, ресурсоснабжающей или
        иной организации для целей передачи показаний приборов учёта.
      </p>
      <p className="pb-2 indent-0">
        2.8. Передача данных авторизации осуществляется исключительно добровольно и по усмотрению Пользователя. Пользователь подтверждает, что имеет надлежащие
        права на использование соответствующего личного кабинета.
      </p>
      <p className="pb-2 indent-0">
        2.9. Компания использует полученные данные исключительно для целей ввода или автоматической передачи показаний, в интересах Пользователя. Пользователь
        не изменяет иную информацию в кабинете, не вносит оплату и не передаёт эти данные третьим лицам.
      </p>
      <p className="pb-2 indent-0">2.10. Компания не несёт ответственности за последствия, вызванные:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>передачей логина и пароля самим Пользователем третьим лицам;</li>
        <li>взломом, сбоем или ограничением доступа к кабинету, произошедшими не по вине Компании;</li>
        <li>техническими ограничениями или изменениями функциональности сторонних платформ.</li>
      </ul>
      <p className="pb-2 indent-0">
        2.11. Пользователь вправе в любой момент отозвать данные доступа или изменить пароль. После отзыва доступа Компания прекращает использование
        соответствующего кабинета без необходимости дополнительных уведомлений.
      </p>

      <p className="font-bold text-center py-4">3. ОТВЕТСТВЕННОСТЬ СТОРОН</p>
      <p className="pb-2 indent-0">
        3.1. Программы, доступ к которым предоставляется Пользователю, функционируют по принципу «как есть» (as is). Компания не гарантирует их бесперебойную и
        безошибочную работу, соответствие конкретным целям и ожиданиям Пользователя, а также не несёт ответственности за возможные ошибки, сбои или иные
        технические неисправности.
      </p>
      <p className="pb-2 indent-0">3.2. Компания не несёт ответственности за:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>последствия, вызванные некорректным использованием Программ Пользователем;</li>
        <li>убытки, причинённые третьими лицами в результате действий Пользователя с нарушением условий настоящего Соглашения;</li>
        <li>
          задержки, сбои и ошибки в работе Программ, вызванные действиями операторов связи, интернет-провайдеров, платёжных систем и иными обстоятельствами,
          находящимися вне контроля Компании;
        </li>
        <li>последствия, вызванные предоставлением Пользователем недостоверной информации при регистрации или использовании Программ;</li>
        <li>
          невозможность использования Программ по причинам, связанным с техническими характеристиками устройства Пользователя, его программным обеспечением,
          отсутствием подключения к сети интернет и иным аналогичным обстоятельствам.
        </li>
      </ul>
      <p className="pb-2 indent-0">
        3.3. Компания обязуется применять надлежащие меры для обеспечения безопасности обработки персональных данных, однако не несёт ответственности за
        действия третьих лиц, получивших несанкционированный доступ в результате действий самого Пользователя (например, при передаче пароля или использовании
        небезопасного устройства).
      </p>
      <p className="pb-2 indent-0">3.4. Пользователь несёт персональную ответственность за:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>сохранность реквизитов доступа к Личному кабинету;</li>
        <li>любые действия, совершённые с использованием его учётной записи;</li>
        <li>достоверность, актуальность и полноту предоставляемых данных;</li>
        <li>соблюдение условий настоящего Соглашения, а также действующего законодательства при использовании Программ.</li>
      </ul>
      <p className="pb-2 indent-0">
        3.5. В случае если Пользователь не осуществляет вход в Личный кабинет более трёх лет, Компания вправе удалить учётную запись и связанные с ней данные с
        предварительным уведомлением Пользователя по указанному адресу электронной почты.
      </p>
      <p className="pb-2 indent-0">
        3.6. Компания не выплачивает компенсаций за упущенную выгоду, моральный вред или иные косвенные убытки, понесённые Пользователем в связи с
        использованием или невозможностью использования Программ.
      </p>
      <p className="pb-2 indent-0">
        3.7. Ответственность Компании по каждому конкретному случаю ограничивается суммой фактически уплаченной Пользователем за оказанную услугу в рамках
        настоящего Соглашения.
      </p>
      <p className="pb-2 indent-0">
        3.8. Компания не несёт ответственности за невозможность использования Программ, вызванную обстоятельствами непреодолимой силы (форс-мажор), включая, но
        не ограничиваясь: стихийными бедствиями, пожарами, наводнениями, отключениями электроснабжения, сбоями в работе интернета, действиями государственных
        органов и другими событиями, не зависящими от воли Компании.
      </p>

      <p className="font-bold text-center py-4">4. ПРАВА И ОБЯЗАННОСТИ СТОРОН</p>
      <p className="pb-2 indent-0">4.1. Пользователь вправе:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>использовать Программы, включая веб-сайт и мобильные приложения, в объёме и на условиях, предусмотренных настоящим Соглашением;</li>
        <li>задавать вопросы, направлять обращения и претензии через формы обратной связи или иные предусмотренные интерфейсы Платформы;</li>
        <li>
          получать доступ к информации о своей учетной записи, показаниям приборов учёта, истории платежей и иным функциям Программ, доступным по выбранной
          модели подключения;
        </li>
        <li>использовать данные и информацию, полученные через Программы, в личных целях;</li>
        <li>прекращать использование Программ в любой момент по собственному усмотрению, за исключением случаев наличия действующих обязательств.</li>
      </ul>
      <p className="pb-2 indent-0">4.2. Пользователь обязуется:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>
          при использовании счётчиков с передачей данных через сотовую связь, оплачивать ежегодный сервисный сбор в размере 180 (ста восьмидесяти) рублей за
          каждый такой счётчик. В указанную стоимость входит передача показаний через оператора связи, уведомления Пользователю, а также отправка показаний на
          портал mos.ru. Указанная сумма может корректироваться Компанией в одностороннем порядке в случае изменения тарифов связи и иных сопутствующих
          расходов;
        </li>
        <li>самостоятельно отслеживать статус своей учётной записи и баланс обязательных платежей в соответствующем разделе Программы;</li>
        <li>не предпринимать действий, нарушающих работу Программы, или создающих необоснованную нагрузку на инфраструктуру Компании;</li>
        <li>соблюдать нормы законодательства Российской Федерации при использовании Программы;</li>
        <li>не предпринимать попыток обхода технических ограничений, взлома, модификации или иного вмешательства в работу Программы;</li>
        <li>
          не использовать функционал Программы в целях, не предусмотренных её назначением, включая недобросовестное использование или предоставление ложной
          информации;
        </li>
        <li>
          ознакомиться с Политикой конфиденциальности и обработки персональных данных, опубликованной на Сайте, и соблюдать установленные ею требования.
        </li>
      </ul>
      <p className="pb-2 indent-0">4.3. Компания вправе:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>приостанавливать или ограничивать доступ к Программам в случае нарушения Пользователем условий настоящего Соглашения;</li>
        <li>изменять функциональность Программ, обновлять интерфейс, внедрять новые функции без согласия Пользователя;</li>
        <li>публиковать уведомления, обязательные для ознакомления, в интерфейсе Программ;</li>
        <li>
          взимать плату за сервисные функции, включая передачу показаний по каналам связи, в порядке и на условиях, предусмотренных настоящим Соглашением;
        </li>
        <li>использовать обезличенные статистические данные о работе Программ и действиях Пользователей для анализа и улучшения сервиса.</li>
      </ul>
      <p className="pb-2 indent-0">4.4. Компания обязуется:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>обеспечивать функционирование Программ в соответствии с их назначением;</li>
        <li>своевременно информировать Пользователей о значимых изменениях условий обслуживания через интерфейс Программ;</li>
        <li>соблюдать требования законодательства Российской Федерации при обработке персональных данных Пользователей;</li>
        <li>предоставлять Пользователям техническую поддержку в объёме, предусмотренном функционалом Программ и условиями настоящего Соглашения;</li>
        <li>
          обеспечивать сохранность данных Пользователей, за исключением случаев, вызванных действиями третьих лиц или форс-мажорными обстоятельствами.
        </li>
      </ul>
      <p className="pb-2 indent-0">
        4.5. Пользователь принимает на себя обязательство по оплате сервисного сбора в случае подключения и использования счётчиков, передающих данные с
        помощью сим-карт. В случае неоплаты, Компания вправе ограничить функциональность, связанную с передачей и отображением данных по соответствующим
        приборам учёта.
      </p>
      <p className="pb-2 indent-0">
        4.6. В случае изменения условий оказания сервисных функций, связанных с передачей данных, Компания уведомляет Пользователя путём публикации информации
        в интерфейсе Программы. Продолжение использования функций означает согласие с изменениями.
      </p>
      <p className="pb-2 indent-0">
        4.7. Пользователь подтверждает, что осознаёт риски, связанные с передачей информации через интернет, и соглашается с тем, что Компания предпринимает
        разумные меры для защиты такой информации, включая организационно-технические средства защиты.
      </p>
      <p className="pb-2 indent-0">
        4.8. Пользователь выражает согласие на обработку персональных данных, необходимых для исполнения настоящего Соглашения, включая автоматизированную
        обработку, передачу информации операторам связи и иным лицам в рамках исполнения условий предоставления сервиса.
      </p>
      <p className="pb-2 indent-0">
        4.9. В случае внедрения новых функций или сервисов в Программе, Пользователь выражает согласие на возможное изменение условий использования
        соответствующих сервисов с уведомлением через интерфейс Платформы.
      </p>

      <p className="font-bold text-center py-4">5. ОБНОВЛЕНИЯ ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ УСТРОЙСТВ</p>
      <p className="pb-2 indent-0">
        5.1. В целях настоящего Соглашения под программным обеспечением устройства понимается встроенное программное обеспечение, микропрограмма, прошивка,
        конфигурационные файлы, параметры работы, алгоритмы обмена данными и иные программные компоненты, обеспечивающие функционирование устройств MERIDIAN
        kolibri, подключенных к Платформе.
      </p>
      <p className="pb-2 indent-0">
        5.2. Пользователь понимает и соглашается с тем, что корректная работа устройств MERIDIAN kolibri может зависеть от актуальности установленного на
        устройстве программного обеспечения. Обновления программного обеспечения устройства могут быть необходимы для обеспечения стабильности работы,
        информационной безопасности, совместимости с Платформой, корректной передачи показаний, устранения ошибок, оптимизации энергопотребления, улучшения
        алгоритмов работы, поддержки новых функций, а также исполнения требований законодательства, операторов связи, интеграционных сервисов и иных
        технических условий.
      </p>
      <p className="pb-2 indent-0">
        5.3. Компания вправе разрабатывать, выпускать, направлять и устанавливать обновления программного обеспечения устройств MERIDIAN kolibri, в том числе
        дистанционно, с использованием доступных каналов связи устройства, Платформы, мобильного приложения, личного кабинета Пользователя, беспроводных сетей,
        каналов NB-IoT, Wi-Fi, Bluetooth или иных технически доступных способов.
      </p>
      <p className="pb-2 indent-0">
        5.4. Принимая настоящее Соглашение, Пользователь предоставляет Компании согласие на получение и установку обновлений программного обеспечения
        устройства, включая автоматические обновления, которые могут выполняться без дополнительного активного участия Пользователя, если такая возможность
        предусмотрена технической архитектурой устройства и Платформы.
      </p>
      <p className="pb-2 indent-0">
        5.5. Компания вправе устанавливать обновления программного обеспечения устройства без отдельного предварительного запроса согласия Пользователя в
        каждом конкретном случае, если такие обновления:
      </p>
      <ul className="list-disc pl-10 pb-2">
        <li>направлены на поддержание работоспособности устройства и Платформы;</li>
        <li>устраняют ошибки, сбои, уязвимости или иные технические недостатки;</li>
        <li>обеспечивают безопасность устройства, данных Пользователя и инфраструктуры Компании;</li>
        <li>улучшают стабильность передачи, хранения или обработки показаний;</li>
        <li>не лишают устройство основных заявленных функций;</li>
        <li>не ухудшают работоспособность устройства по сравнению с его назначением;</li>
        <li>не приводят к необоснованному расходу платного трафика Пользователя.</li>
      </ul>
      <p className="pb-2 indent-0">
        5.6. Компания информирует Пользователя о факте выпуска, установки или результате установки обновления одним или несколькими доступными способами: через
        push-уведомление, сообщение в Личном кабинете, запись в списке событий устройства, уведомление в мобильном приложении, сообщение на адрес электронной
        почты либо иным способом, предусмотренным функциональностью Платформы. В случае срочных обновлений, связанных с безопасностью, устранением критических
        ошибок или обеспечением работоспособности устройства, уведомление может быть направлено после установки обновления.
      </p>
      <p className="pb-2 indent-0">
        5.7. Пользователь понимает и соглашается с тем, что для установки обновлений устройство должно иметь техническую возможность связи с Платформой или
        мобильным приложением. Если устройство временно недоступно, отключено, находится вне зоны действия сети, не имеет доступа к Wi-Fi, NB-IoT, Bluetooth или
        иному каналу связи, обновление может быть установлено позднее, при восстановлении технической возможности передачи данных.
      </p>
      <p className="pb-2 indent-0">
        5.8. Пользователь обязуется не препятствовать установке обновлений программного обеспечения устройства, не выполнять действия, направленные на обход,
        блокировку, изменение или нарушение работы механизмов обновления, а также не использовать неофициальные версии программного обеспечения, не
        предоставленные Компанией.
      </p>
      <p className="pb-2 indent-0">
        5.9. Компания не несёт ответственности за невозможность установки обновления, задержку установки обновления, некорректное завершение обновления или
        временное ограничение работы устройства, если такие обстоятельства вызваны отсутствием связи, нестабильной сетью, недостаточным уровнем заряда
        элемента питания, вмешательством Пользователя или третьих лиц, нарушением инструкции по эксплуатации, несанкционированным изменением устройства,
        использованием неофициального программного обеспечения либо иными обстоятельствами, находящимися вне разумного контроля Компании.
      </p>
      <p className="pb-2 indent-0">
        5.10. В период установки обновления отдельные функции устройства или Платформы могут быть временно недоступны либо работать с ограничениями. Такие
        ограничения являются технически обусловленными и не считаются нарушением условий настоящего Соглашения, если после завершения обновления устройство
        сохраняет основные заявленные функции.
      </p>
      <p className="pb-2 indent-0">
        5.11. Компания принимает разумные меры для того, чтобы обновления программного обеспечения устройства не приводили к утрате показаний, пользовательских
        настроек и иных данных, необходимых для корректной работы устройства. При этом Пользователь понимает, что отдельные технические параметры устройства
        могут быть изменены или оптимизированы в результате обновления, если это необходимо для стабильной, безопасной и корректной работы устройства и
        Платформы.
      </p>

      <p className="font-bold text-center py-4">6. ОБРАБОТКА ПЕРСОНАЛЬНЫХ ДАННЫХ</p>
      <p className="pb-2 indent-0">
        6.1. Оператором персональных данных, обрабатываемых в рамках использования Программ, является Общество с ограниченной ответственностью «МЕРИДИАН»
        (ОГРН: 5087746158880, ИНН: 7734592378, юридический адрес: г. Москва, ул. Малая Калужская, д. 15, стр. 17).
      </p>
      <p className="pb-2 indent-0">
        6.2. Обработка персональных данных Пользователей осуществляется в соответствии с действующим законодательством Российской Федерации и Политикой
        конфиденциальности и обработки персональных данных, опубликованной на официальном сайте Компании по адресу:{' '}
        <a href="https://meridian.pro" target="_blank" rel="noopener noreferrer">
          https://meridian.pro
        </a>{' '}
        (далее — Политика).
      </p>
      <p className="pb-2 indent-0">
        6.3. Ознакомление с Политикой является обязательным условием использования Программ. Использование Программ, включая активацию функционала, регистрацию
        или отправку форм, означает согласие Пользователя с условиями обработки персональных данных, изложенными в Политике.
      </p>
      <p className="pb-2 indent-0">
        6.4. Согласие на обработку персональных данных предоставляется Пользователем в форме проставления чекбокса в соответствующей форме Программы,
        сопровождаемой активной гиперссылкой на текст согласия и Политику.
      </p>
      <p className="pb-2 indent-0">
        6.5. Перечень обрабатываемых персональных данных, цели, правовые основания, сроки и иные условия обработки установлены Политикой.
      </p>
      <p className="pb-2 indent-0">
        6.6. Пользователь обязуется предоставлять только достоверные и актуальные персональные данные. В случае изменения персональных данных Пользователь
        обязуется своевременно внести изменения в своей учётной записи или уведомить Компанию.
      </p>
      <p className="pb-2 indent-0">
        6.7. Компания принимает необходимые правовые, организационные и технические меры по защите персональных данных Пользователей от неправомерного или
        случайного доступа, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий.
      </p>
      <p className="pb-2 indent-0">
        6.8. Все запросы субъектов персональных данных обрабатываются Компанией в порядке, установленном Регламентом рассмотрения запросов субъектов
        персональных данных, утверждённым Компанией и размещённым на сайте Компании.
      </p>

      <p className="font-bold text-center py-4">7. ИНТЕЛЛЕКТУАЛЬНАЯ СОБСТВЕННОСТЬ</p>
      <p className="pb-2 indent-0">
        7.1. Все элементы Программ, включая, но не ограничиваясь: программным кодом, базой данных, дизайном интерфейсов, текстами, графическими элементами,
        логотипами, а также структурой и логикой взаимодействия между компонентами — являются объектами исключительных прав Компании и (или) её лицензиаров и
        охраняются в соответствии с законодательством Российской Федерации.
      </p>
      <p className="pb-2 indent-0">
        7.2. Пользователь получает неисключительное, непередаваемое, ограниченное право использовать Программы исключительно в личных целях в объёме,
        определённом настоящим Соглашением. Никакие положения настоящего Соглашения не подразумевают передачу исключительных прав на элементы Программ.
      </p>
      <p className="pb-2 indent-0">7.3. Пользователь не вправе:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>
          копировать, воспроизводить, распространять, модифицировать, декомпилировать, изменять или иным способом использовать Программы, за исключением
          случаев, прямо предусмотренных законодательством или настоящим Соглашением;
        </li>
        <li>извлекать, систематизировать и/или использовать базу данных Программ или её части без письменного согласия Компании;</li>
        <li>использовать элементы Программ в коммерческих целях или для создания производных продуктов.</li>
      </ul>
      <p className="pb-2 indent-0">
        7.4. Нарушение Пользователем положений настоящего раздела может повлечь за собой привлечение к ответственности в соответствии с действующим
        законодательством Российской Федерации, включая, но не ограничиваясь: компенсацией убытков, блокировкой доступа, взысканием за незаконное
        использование интеллектуальной собственности.
      </p>
      <p className="pb-2 indent-0">
        7.5. Использование в Программах отдельных компонентов, прав на которые принадлежат третьим лицам (в том числе open source-библиотек), осуществляется на
        условиях соответствующих лицензий, соблюдение которых является обязательным для Пользователя при взаимодействии с такими компонентами.
      </p>
      <p className="pb-2 indent-0">
        7.6. Любое использование товарных знаков, фирменных наименований и других объектов индивидуализации Компании без её письменного согласия не допускается.
      </p>

      <p className="font-bold text-center py-4">8. РАЗРЕШЕНИЕ СПОРОВ</p>
      <p className="pb-2 indent-0">
        8.1. В случае возникновения любых разногласий или споров между Компанией и Пользователем, обязательным условием до обращения в суд является предъявление
        претензии — письменного обращения с изложением сути спора и требованиями.
      </p>
      <p className="pb-2 indent-0">
        8.2. Претензии физических лиц рассматриваются Компанией в срок до 10 (десяти) рабочих дней с даты получения. Претензии юридических лиц рассматриваются
        в срок до 30 (тридцати) календарных дней. В случае, если для рассмотрения требуется запрос дополнительных сведений у Пользователя, срок может быть
        продлён, но не более чем на 10 (десять) рабочих дней с момента уведомления Пользователя о продлении срока.
      </p>
      <p className="pb-2 indent-0">
        8.3. Претензия подаётся в письменной форме по электронной почте, указанной в разделе «Контакты». Претензия должна содержать сведения, позволяющие
        идентифицировать Пользователя и предмет спора, а также приложенные документы, подтверждающие изложенные доводы.
      </p>
      <p className="pb-2 indent-0">
        8.4. При невозможности разрешения спора в досудебном порядке, спор подлежит рассмотрению в судебном порядке по месту нахождения Компании, если иное не
        предусмотрено законодательством Российской Федерации.
      </p>

      <p className="font-bold text-center py-4">9. ИЗМЕНЕНИЕ УСЛОВИЙ СОГЛАШЕНИЯ</p>
      <p className="pb-2 indent-0">
        9.1. Компания оставляет за собой право в любое время изменять условия настоящего Соглашения, Политику конфиденциальности и иные связанные документы.
        Изменения вступают в силу с момента их публикации на Платформе, если иное не предусмотрено самими изменениями.
      </p>
      <p className="pb-2 indent-0">
        9.2. Продолжение использования Платформы Пользователем после внесения изменений в Соглашение означает согласие Пользователя с такими изменениями. В
        случае несогласия Пользователь обязан прекратить использование Платформы.
      </p>
      <p className="pb-2 indent-0">
        9.3. Компания вправе уведомить Пользователя о существенных изменениях в Соглашении, размещая соответствующее уведомление в интерфейсе Платформы,
        направляя его по электронной почте либо иным доступным способом, если Пользователь предоставил соответствующие контактные данные.
      </p>
      <p className="pb-2 indent-0">
        9.4. Пользователь обязуется самостоятельно и регулярно отслеживать актуальную версию Соглашения, размещённую на сайте Платформы, особенно перед
        использованием функционала, предполагающего внесение оплаты.
      </p>

      <p className="font-bold text-center py-4">Компания</p>
      <p className="pb-2 indent-0">ООО «МЕРИДИАН»</p>
      <p className="pb-2 indent-0">ОГРН: 5087746158880</p>
      <p className="pb-2 indent-0">ИНН: 7734592378</p>
      <p className="pb-2 indent-0">Юридический адрес: г. Москва ул. Малая Калужская, д.15, стр.17</p>
      <p className="pb-2 indent-0">
        Email для корреспонденции:{' '}
        <a href="mailto:info@meridian.pro">info@meridian.pro</a>
      </p>
    </div>
  );
};

export default Declaration;
